import type { ReactNode } from "react";
import {
    Dialog,
    DialogBody,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog.tsx";
import Icon from "@/components/ui/icon";
import Image from "@/components/ui/image.tsx";
import type { ImageType, Nullable } from "@/types";

// * TL;DR;
// * ToolTip that renders as a modal 😆

type Props = { label: ReactNode; tooltip: Nullable<string>; image: Nullable<ImageType> };
export default function ChoiceTooltip({ label, tooltip, image }: Props) {
    if (!tooltip) return null;

    return (
        <Dialog>
            <DialogTrigger className="choice-tooltip__trigger">
                <Icon name="info-circle" />
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{label}</DialogTitle>
                </DialogHeader>
                <DialogBody className="choice-tooltip__content">
                    {/* TODO: Alt? */}
                    {image !== null && <Image image={image} alt="" className="choice-tooltip__image" />}
                    <div dangerouslySetInnerHTML={{ __html: tooltip }} className="choice-tooltip__description" />
                </DialogBody>
            </DialogContent>
        </Dialog>
    );
}
